import React from 'react';
import { Typography } from '@mui/material';
import { useTheme } from '../../util/themes';

interface HelperInputTextProps {
  text: any;
  error?: boolean;
}

function HelperInputText(props: HelperInputTextProps) {
  const theme = useTheme();

  return (
    <Typography
        ml={1}
        variant="subtitle2"
        fontSize={'0.75rem'}
        sx={{
          marginLeft: '14px',
          fontStyle: 'italic',
          color: props.error ? '#D32F2F' : theme.colors.text.secondary,
        }}
    >
      {props.text}
    </Typography>
  );
}

export default HelperInputText;














